import { render } from "./SellerOverview.vue?vue&type=template&id=1c252b1d&ts=true"
import script from "./SellerOverview.vue?vue&type=script&lang=ts"
export * from "./SellerOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__